import React, { useState } from 'react';

import styles from './index.module.less';
import defaultPicture from './default-picture.png';
import{addVisitLog, history} from 'libs';
import {observer} from "mobx-react";
import cartStore from "pages/cart/store"
import {message} from 'antd';

const goDetail = (item)=>{
    addVisitLog({
        pageName: '产品详情页',
        fromPageUrl: history.location.pathname,
        pageUrl:`${window.location.origin}/goods/detail?id=${item.id}`,
        eventCode: "ProductDetail",
        eventName: "查看产品详情",
        content: JSON.stringify(item),
    })
    window.open('/goods/detail?id=' + item.id,'_blank')
    }
// 加入购物车 - 添加防重复点击逻辑
const createBuyHandler = (loadingMap, setLoadingMap) => {
  return async (record = {}, isBuy = true) => {
    const key = `${record.id}-${isBuy}`;
    if (loadingMap[key]) return; // 正在加载中，阻止重复点击

    let eventCode = 'ProductListRent';
    let eventName = '产品列表租';
    if (isBuy) {
      eventCode = 'ProductListSale';
      eventName = '产品列表买';
    }

    addVisitLog({
      pageName: eventName,
      fromPageUrl: window.referrerUrl,
      pageUrl: `${window.location.origin}${history.location.pathname}`,
      eventCode: eventCode,
      eventName: eventName,
    });

    // 设置加载状态
    setLoadingMap(prev => ({ ...prev, [key]: true }));

    try {
      await cartStore.addRecord(record.id, isBuy ? record.saleCatalog : record.leaseCatalog);
    } catch (error) {
      console.error('Add to cart failed:', error);
    } finally {
      // 清除加载状态
      setLoadingMap(prev => ({ ...prev, [key]: false }));
    }
  };
};
const ListTemplate = ({ skuList = [], }) => {
  // 使用对象存储每个按钮的加载状态，key 为 "商品id-操作类型"
  const [loadingMap, setLoadingMap] = useState({});
  const handleBuy = createBuyHandler(loadingMap, setLoadingMap);

  return (
    <div className={styles['list-wrapper']}>
    {skuList.map((item, index) => (
      <div
        className={styles['list-content']}
        key={item.skuNo || index}
        onClick={() => goDetail(item)}
      >
        <div className={styles['goods-pic'] + ' font0'}>
          {item?.thumb ? (
            <img src={item.thumb} alt={item.name} />
          ) : (
            <img src={defaultPicture} className={styles.default_img}/>
          )}
          <div className={styles['picture-shadow']}></div>
        </div>
        <div className={styles['goods-name']} title={item.name}>{item.name}</div>
        <div className={styles['goods-brand']} title={item.brand+' | '+item.factoryCode}>
         {item.brand}&nbsp;&nbsp;|&nbsp;&nbsp;{item.factoryCode}
          {/* <span className={styles['brand-line']}>|</span>
          <span className='factoryCode'>{item.factoryCode}</span> */}
        </div>
        <div className={styles['opera-button']}>
          {item['leaseAble'] ? (
            <div
              className={`${styles['opera-button-common']} ${styles['opera-button-primary']}`}
              onClick={v => {
                v.stopPropagation(); // 始终阻止冒泡
                handleBuy(item, false);
              }}
            >
              {loadingMap[`${item.id}-false`] ? '处理中...' : '租赁'}
            </div>
          ) : null}
          {item['saleAble'] ? (
            <div
              className={`${styles['opera-button-common']} ${styles['opera-button-theme']}`}
              onClick={v => {
                v.stopPropagation(); // 始终阻止冒泡
                handleBuy(item, true);
              }}
            >
              {loadingMap[`${item.id}-true`] ? '处理中...' : '采购'}
            </div>
          ) : null}
        </div>
      </div>
    ))}
    </div>
  );
};


export default observer(ListTemplate);